import React from 'react';
export const ProductIntroSection = () => {
  return <section className="bg-white py-10 px-5 sm:px-10" data-id="element-223">
      <div className="max-w-[1100px] mx-auto text-center" data-id="element-224">
        <div className="inline-block bg-biosync-menta text-biosync-dark font-bold text-sm sm:text-base py-2 px-6 rounded-full mb-8" data-id="element-225">
          ⚡ El Sistema de Regulación Emocional Más Completo para Adolescentes
          en Habla Hispana
        </div>

        <h2 className="text-4xl sm:text-5xl md:text-[44px] font-bold text-biosync-text mb-4" data-id="element-226">
          BIO-SYNC™
          <br data-id="element-227" />
          EL CÓDIGO DE REGULACIÓN EMOCIONAL
        </h2>

        <h3 className="text-xl sm:text-2xl text-biosync-textSec font-semibold mb-8" data-id="element-228">
          Ebook Principal + 6 Módulos + 3 Bonos — Todas las edades — Todo
          resuelto.
        </h3>

        <p className="text-base sm:text-lg text-biosync-textSec max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-229">
          +300 páginas · 6 módulos de 30 páginas · 3 bonos · Ansiedad ·
          Impulsividad · Autoestima · Límites · Conexión · Rutina de
          mantenimiento.
          <br data-id="element-230" />
          Funciona desde hoy. En cualquier país.
        </p>

        <div className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-231">
          <span className="bg-biosync-azul text-biosync-text font-bold uppercase text-xs py-2 px-4 rounded-full" data-id="element-232">
            Ansiedad
          </span>
          <span className="bg-biosync-amarillo text-biosync-text font-bold uppercase text-xs py-2 px-4 rounded-full" data-id="element-233">
            Impulsividad
          </span>
          <span className="bg-biosync-lavanda text-biosync-text font-bold uppercase text-xs py-2 px-4 rounded-full" data-id="element-234">
            Autoestima
          </span>
          <span className="bg-biosync-rosa text-biosync-text font-bold uppercase text-xs py-2 px-4 rounded-full" data-id="element-235">
            Límites
          </span>
          <span className="bg-biosync-durazno text-biosync-text font-bold uppercase text-xs py-2 px-4 rounded-full" data-id="element-236">
            Upgrade
          </span>
        </div>

        <div className="flex flex-col items-center gap-4 max-w-2xl mx-auto text-left" data-id="element-237">
          {['Sistema completo por área emocional', 'Actividades prácticas de 5 minutos', 'Protocolos de emergencia listos para usar', 'Diarios guiados y herramientas de reflexión', 'Bibliografía científica APA en cada módulo', 'Español neutro, funciona en cualquier país'].map((bullet, i) => <div key={i} className="flex items-center gap-3 w-full sm:w-auto sm:min-w-[400px]" data-id="element-238">
              <span className="text-biosync text-xl" data-id="element-239">✅</span>
              <span className="text-biosync-text font-medium text-base sm:text-lg" data-id="element-240">
                {bullet}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
};